import { ENV_VARIABLES } from './envConfig';

interface GoBotStageConfig {
    clientBaseUrl: string;
    serverBaseUrl: string;
}

const gobotStageConfigs: Record<'beta' | 'prod' | 'dev', GoBotStageConfig> = {
    beta: {
        clientBaseUrl: 'https://beta.client.mcp.huron.ats.amazon.dev',
        serverBaseUrl: 'https://4t0jnp4m9e.execute-api.us-east-1.amazonaws.com/BETA',
    },
    prod: {
        clientBaseUrl: 'https://client.mcp.huron.ats.amazon.dev',
        serverBaseUrl: 'https://fyzzza15f3.execute-api.us-east-1.amazonaws.com/PROD',
    },
    dev: {
        clientBaseUrl: 'https://beta.client.mcp.huron.ats.amazon.dev',
        serverBaseUrl: 'https://4t0jnp4m9e.execute-api.us-east-1.amazonaws.com/BETA',
    },
};

const determineCurrentStage = (): 'beta' | 'prod' | 'dev' => {
    const s = (ENV_VARIABLES.stage || 'beta').toLowerCase();
    if (s === 'prod' || s === 'production') return 'prod';
    if (s === 'dev' || s === 'development' || s === 'local') return 'dev';
    return 'beta';
};

export const CURRENT_STAGE = determineCurrentStage();
export const GOBOT_STAGE_CONFIG = gobotStageConfigs[CURRENT_STAGE];

export const getChatUrl = (): string =>
    `${GOBOT_STAGE_CONFIG.clientBaseUrl}/chat`;

export const getFeedbackUrl = (): string =>
    `${GOBOT_STAGE_CONFIG.serverBaseUrl}/saveUserFeedbackData`;